import {Image} from 'platform/foundation';

import {AdServer} from '../../../types/AdServer';

/** Height cap on the spacing scale; the wordmark keeps its ratio via fit=contain. */
const LOGO_MAX_HEIGHT = 4;

interface AdServerLogoProps {
  adServer: string;
}

/**
 * Wordmark logo of an advertisement server (SVG, except Volvo Selekt which is a PNG).
 * Sized by its container — give the wrapping element a max-width so the logo can
 * shrink with tight layouts instead of overflowing them.
 */
export function AdServerLogo(props: AdServerLogoProps) {
  const extension = props.adServer === AdServer.VOLVO_SELEKT ? 'png' : 'svg';

  return (
    <Image
      src={`/assets/images/ad-server-logo/${props.adServer}.${extension}`}
      maxHeight={LOGO_MAX_HEIGHT}
      maxWidth="100%"
      fit="contain"
      position="left"
    />
  );
}
